import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import auth from "../services/authService.js";
import Joi from "joi-browser";
class RegisterUserForm extends Component {
  state = {
    account: { fullname: "", company: "", username: "", password: "" },
    errors: { fullname: "", company: "", username: "", password: "" }
  };

  schema = {
    username: Joi.string()
      .email()
      .required()
      .label("Email"),
    password: Joi.string()
      .required()
      .label("Password"),
    fullname: Joi.string()
      .required()
      .label("Full Name"),
    company: Joi.string()
      .required()
      .label("Company")
  };
  recaptchaRef = React.createRef();
  handleSubmit = async e => {
    e.preventDefault();

    const recaptchaValue = this.recaptchaRef.current.getValue();
    if (!recaptchaValue) return;

    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;
    const result = await auth.register(this.state.account);
    if (result.isOk) {
      auth.loginWithJwt(result.user);
      this.props.onLogin();
      this.props.history.replace("/");
    } else {
      const errors = {};
      errors.registerResult = result.errorMessage;
      this.setState({ errors });
    }
  };

  validate = () => {
    const result = Joi.validate(this.state.account, this.schema, {
      abortEarly: false
    });
    if (!result.error) return null;
    const errors = {};
    for (let item of result.error.details) errors[item.path[0]] = item.message;
    return errors;
  };
  handleChange = ({ currentTarget: input }) => {
    const account = { ...this.state.account };
    account[input.name] = input.value;
    this.setState({ account });
  };
  render() {
    const { account, errors } = this.state;
    return (
      <div className="card">
        <div className="card-body">
          <div className="card-title">Register to share your suggestions</div>
          <form onSubmit={this.handleSubmit}>
            {errors.registerResult && (
              <div className="alert alert-danger">{errors.registerResult}</div>
            )}
            <div className="form-group">
              <input
                name="fullname"
                onChange={this.handleChange}
                type="input"
                value={account.fullname}
                className="form-control"
                id="fullname"
                placeholder="Full Name"
              />
              {errors.fullname && (
                <div className="alert alert-danger">{errors.fullname}</div>
              )}
            </div>
            <div className="form-group">
              <input
                name="company"
                onChange={this.handleChange}
                type="input"
                value={account.company}
                className="form-control"
                id="company"
                placeholder="Company Name"
              />
              {errors.company && (
                <div className="alert alert-danger">{errors.company}</div>
              )}
            </div>
            <div className="form-group">
              <input
                name="username"
                onChange={this.handleChange}
                type="email"
                value={account.username}
                className="form-control"
                id="username"
                aria-describedby="emailHelp"
                placeholder="Email Address"
              />
              {errors.username && (
                <div className="alert alert-danger">{errors.username}</div>
              )}
            </div>
            <div className="form-group">
              <input
                name="password"
                onChange={this.handleChange}
                value={account.password}
                type="password"
                className="form-control"
                id="password"
                placeholder="Password"
                autoComplete="off"
              />
              {errors.password && (
                <div className="alert alert-danger">{errors.password}</div>
              )}
            </div>
            <div className="mb-1">
              <ReCAPTCHA
                ref={this.recaptchaRef}
                sitekey="6Led2MYUAAAAAN7FXktkwI0KZ00IWRGfP47xg7h1"
              />
            </div>
            <button type="submit" className="btn btn-primary">
              Register
            </button>
          </form>
        </div>
      </div>
    );
  }
}

export default RegisterUserForm;
